import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Carousel, Panel, Text } from '@gasbuddy/react-components';
import styles from './GasPriceCollection.module.css';

import FuelPropType from '../../prop-types/fuel';
import FuelTypePriceDisplay from '../FuelTypePriceDisplay';
import getDisplayableFuels from '../../../lib/utils/getDisplayableFuels';

const cx = classnames.bind(styles);

export default function GasPriceCollection({ fuels, showCashPrices }) {
  if (!fuels.length) {
    return null;
  }

  const priceSets = getDisplayableFuels(fuels);

  return (
    <Panel bordered color="white" padded={false}>
      {showCashPrices && (
        <div className={cx('pillContainer')}>
          <div className={cx('pill', 'cash')}>
            <Text bold centered color="white" size="sm" uppercase>Cash</Text>
          </div>
          <br /><br /><br />
          <div className={cx('pill', 'credit')}>
            <Text bold centered color="white" size="sm" uppercase>Credit</Text>
          </div>
        </div>
      )}
      <Carousel className={cx('collectionContainer', { withTabs: showCashPrices })} scrollable>
        {priceSets.map(set => (
          <div key={set.fuelType} className={cx('fuelTypePriceSection')}>
            <Text centered>{set.displayName}</Text>
            <br />
            <div className={cx('priceDisplay')}>
              {/* Some stations used to have cash prices, but no longer do, so they shouldn't be shown */}
              {/* Also, we need to ensure we show the cash prices first, hence the sort */}
              {set.prices
                .sort((a, b) => b.isCash - a.isCash)
                .map(priceReport => (!priceReport.isCash || (priceReport.isCash && showCashPrices)) && (
                  <FuelTypePriceDisplay
                    key={`${set.fuelType} ${priceReport.isCash ? 'Cash' : 'Credit'} Prices`}
                    priceReport={priceReport}
                  />
                ))
              }
            </div>
          </div>
        ))}
      </Carousel>
    </Panel>
  );
}

GasPriceCollection.propTypes = {
  fuels: PropTypes.arrayOf(FuelPropType).isRequired,
  showCashPrices: PropTypes.bool,
};

GasPriceCollection.defaultProps = {
  showCashPrices: false,
};
